module.exports = {
  email_vch: "admin",
  firstname_vch: "LOCAL",
  lastname_vch: "USER",
  user_id_bint: 11,
  active_ti: 1,
  created_dt: "2020-02-21T05:00:14.000Z",
  updated_dt: "2020-02-21T05:00:14.000Z",
  iat: 1582232700,
  exp: 1582319100,
};
